import { render, staticRenderFns } from "./modal-mitra-tna-detail.vue?vue&type=template&id=2bfc0d2d&scoped=true"
import script from "./modal-mitra-tna-detail.vue?vue&type=script&lang=js"
export * from "./modal-mitra-tna-detail.vue?vue&type=script&lang=js"
import style0 from "./modal-mitra-tna-detail.vue?vue&type=style&index=0&id=2bfc0d2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc0d2d",
  null
  
)

export default component.exports